// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 올인원 — 여권 탭 (legacy fp-card 재사용 + AllInOne 레이아웃 보강) */

.passport-tab-v2 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  margin: 0 -8px;
}

.passport-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}

.passport-layout {
  display: grid;
  grid-template-columns: 1fr 200px;
  gap: 12px;
  align-items: start;
  flex: 1 1 auto;
  min-height: 0;
}

.passport-grid-area {
  min-width: 0;
  overflow-anchor: none;
}

/* 카드 그리드 — 2열 고정, 카드 사이즈 축소 */
.passport-tab-v2 .fp-card-grid {
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  margin-top: 0;
}
.passport-tab-v2 .fp-card-image {
  aspect-ratio: 3 / 4;
  background: #fff;
  overflow: clip;
  scroll-behavior: auto;
  overscroll-behavior: contain;
}
.passport-tab-v2 .fp-card {
  overflow: clip;
}
.passport-tab-v2 .fp-card-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 4px;
  box-sizing: border-box;
  display: block;
}
.passport-tab-v2 .fp-card-store-label {
  font-size: 11px;
}
.passport-tab-v2 .fp-card-bottom {
  padding: 2px 4px;
}
.passport-tab-v2 .fp-card-select-antd .ant-select-selector {
  height: 22px !important;
  padding: 0 6px !important;
  font-size: 12px !important;
}
.passport-tab-v2 .fp-card-select-antd .ant-select-selection-item {
  line-height: 20px !important;
  font-size: 12px !important;
}
.passport-tab-v2 .fp-card-meta {
  margin-top: 2px;
}

.passport-tab-v2 .fp-card {
  position: relative;
}

.fp-card-meta {
  margin-top: 4px;
  text-align: right;
}

.fp-card-busy-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  border-radius: 10px;
}

.expired-card {
  opacity: 0.55;
}
.expired-card .fp-card-placeholder {
  background: linear-gradient(145deg, #90A4AE, #546E7A);
}

/* 우측 신규 발급 사이드 */
.passport-register-side {
  position: sticky;
  top: 0;
}

.passport-register-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.passport-register-title {
  font-size: 14px;
  font-weight: 700;
  color: #334155;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.passport-form-label {
  font-size: 12px;
  font-weight: 600;
  color: #546E7A;
  margin-bottom: 4px;
}

/* 좁은 화면 (태블릿 세로) — 사이드를 위로 */
@media (max-width: 900px) {
  .passport-layout {
    grid-template-columns: 1fr;
  }
  .passport-register-side {
    position: static;
  }
}

/* 미사용 expired 클래스 정리 */
.expired-card { display: none; }

/* 새 여권 발급 폼 입력 높이 — 대상 Select 와 발급일 DatePicker 동일 24px */
.passport-register-card .ant-select-sm .ant-select-selector,
.passport-register-card .ant-picker-small {
  height: 24px !important;
  min-height: 24px !important;
  line-height: 22px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.passport-register-card .ant-picker-small .ant-picker-input > input {
  font-size: 12px !important;
  height: 22px !important;
  line-height: 22px !important;
}
.passport-register-card .ant-select-sm .ant-select-selection-item {
  line-height: 22px !important;
  font-size: 12px !important;
}

/* 요약 바 폰트 (가족 N명 · 전체 여권 N장) — 가독성 향상 */
.passport-tab-v2 .fp-summary-bar {
  font-size: 17px;
  padding: 10px 16px;
  color: #37474F;
}
.passport-tab-v2 .fp-summary-bar strong {
  font-size: 19px;
  color: #1565C0;
}

/* 2026-09 여권 업무 재배치: 발급 → 보유 현황 → 양도 */
.passport-tab-v2 {
  gap: 12px;
  min-height: 0;
  margin: 0;
  padding: 0 10px 14px;
  overflow-y: auto;
  overflow-anchor: none;
  overscroll-behavior-y: contain;
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
}

.passport-toolbar {
  flex-wrap: nowrap;
  gap: 12px;
  padding-top: 2px;
}

.passport-history-button.ant-btn {
  height: 42px;
  margin-left: 4px;
  padding: 0 16px;
  border-color: #cbd5e1;
  border-radius: 9px;
  color: #334155;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}

.passport-history-button.ant-btn:active {
  background: #f1f5f9;
}

.passport-tab-v2 .fp-summary-bar {
  min-height: 42px;
  padding: 8px 16px;
  border: 1px solid #fde7ad;
  border-radius: 9px;
  background: #fffbeb;
  color: #475569;
  font-size: 15px;
}

.passport-tab-v2 .fp-summary-bar strong {
  color: #0f6ead;
  font-size: 18px;
}

.passport-register-card {
  display: grid;
  grid-template-columns: minmax(220px, 0.7fr) minmax(460px, 1.8fr);
  align-items: center;
  gap: 18px;
  padding: 14px 16px;
  border: 1px solid #cbd5e1;
  border-left: 5px solid #176da5;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.06);
}

.passport-register-intro {
  min-width: 0;
}

.passport-register-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  color: #123b59;
  font-size: 18px;
  font-weight: 800;
}

.passport-register-intro .ant-typography {
  font-size: 13px;
}

.passport-register-fields {
  display: grid;
  grid-template-columns: minmax(150px, 1fr) minmax(170px, 1fr) minmax(150px, 0.8fr);
  align-items: start;
  gap: 10px;
}

.passport-form-field {
  min-width: 0;
}

.passport-form-label {
  margin-bottom: 5px;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
}

.passport-register-card .ant-select {
  height: 42px !important;
}

.passport-register-card .ant-select-selector,
.passport-register-card .ant-picker {
  height: 42px !important;
  min-height: 42px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
}

.passport-register-card .ant-select-selection-item {
  line-height: 40px !important;
  font-size: 14px !important;
  font-weight: 600;
}

.passport-register-card .ant-picker-input > input {
  height: 40px !important;
  font-size: 14px !important;
}

.passport-register-button.ant-btn {
  width: 100%;
  height: 42px;
  border-radius: 8px;
  background: #176da5;
  font-size: 15px;
  font-weight: 800;
  box-shadow: none;
}

.passport-register-action {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
  padding-top: 23px;
}

.passport-register-note {
  min-height: 16px;
  padding: 0 2px;
  color: #8a6110;
  font-size: 11px;
  line-height: 1.35;
  text-align: center;
}

.passport-section-heading {
  display: flex;
  align-items: end;
  justify-content: space-between;
  padding: 2px 4px 0;
}

.passport-section-heading > div {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.passport-section-heading strong {
  color: #1e293b;
  font-size: 17px;
}

.passport-section-heading span {
  color: #64748b;
  font-size: 13px;
}

.passport-grid-area {
  min-width: 0;
  padding-bottom: 4px;
}

.passport-tab-v2 .fp-card-grid {
  grid-template-columns: repeat(auto-fit, minmax(245px, 300px));
  align-items: start;
  gap: 12px;
  margin: 0;
}

.passport-tab-v2 .fp-card {
  position: relative;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.07);
  transition: none;
}

.passport-tab-v2 .fp-card:hover {
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.07);
}

.passport-card-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 58px;
  padding: 8px 10px;
  border-bottom: 1px solid #e2e8f0;
  background: #eef6fb;
}

.passport-card-heading > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.passport-card-eyebrow {
  width: fit-content;
  margin-bottom: 2px;
  padding: 2px 7px;
  border-radius: 999px;
  background: #d9eefa;
  color: #0f5f91;
  font-size: 11px;
  font-weight: 800;
}

.passport-card-owner {
  overflow: hidden;
  color: #123b59;
  font-size: 19px;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.passport-tab-v2 .fp-card-delete {
  position: static;
  width: auto;
  height: 32px;
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #fecaca;
  border-radius: 7px;
  background: #fff;
  color: #b91c1c;
  font-size: 12px;
  font-weight: 700;
}

.passport-tab-v2 .fp-card-delete:active {
  background: #fef2f2;
}

.passport-tab-v2 .fp-card-image {
  position: relative;
  width: 100%;
  height: clamp(185px, 22vh, 245px);
  aspect-ratio: auto;
  overflow: hidden;
  background: #e8eef3;
}

.passport-tab-v2 .fp-card-image img {
  display: block;
  width: 100%;
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
  object-fit: contain;
}

.passport-tab-v2 .fp-card-store-label {
  bottom: 8px;
  left: 10px;
  padding: 5px 10px;
  border-radius: 999px;
  background: rgba(10, 51, 79, 0.92);
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  text-shadow: none;
}

.passport-tab-v2 .fp-card-bottom {
  padding: 10px;
}

.passport-transfer-title {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #334155;
  font-size: 14px;
  font-weight: 800;
}

.passport-transfer-help {
  margin: 2px 0 7px;
  color: #64748b;
  font-size: 11px;
}

.passport-transfer-select-wrap {
  width: 100%;
}

.passport-tab-v2 .fp-card-select-antd .ant-select-selector {
  height: 40px !important;
  min-height: 40px !important;
  padding: 0 10px !important;
  border: 1px solid #94a3b8 !important;
  border-radius: 8px !important;
}

.passport-tab-v2 .fp-card-select-antd .ant-select-selection-item {
  line-height: 38px !important;
  color: #1e293b;
  font-size: 14px !important;
  font-weight: 700;
}

.passport-tab-v2 .fp-card-meta {
  margin-top: 6px;
  text-align: right;
}

.passport-tab-v2 .fp-card-meta .ant-typography {
  font-size: 12px;
}

.fp-card-busy-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.68);
}

@media (max-width: 1100px) {
  .passport-register-card {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .passport-tab-v2 .fp-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .passport-toolbar,
  .passport-section-heading > div {
    align-items: stretch;
    flex-direction: column;
  }

  .passport-register-fields {
    grid-template-columns: 1fr;
  }

  .passport-register-action {
    padding-top: 0;
  }

  .passport-register-button.ant-btn {
    width: 100%;
  }

  .passport-tab-v2 .fp-card-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AllInOne/PassportTab.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,qCAAqC;EACrC,QAAQ;EACR,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,qDAAqD;AACvD;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,uBAAuB;AACvB,gBAAgB,aAAa,EAAE;;AAE/B,yDAAyD;AACzD;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,SAAS;EACT,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gEAAgE;EAChE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iFAAiF;EACjF,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* 올인원 — 여권 탭 (legacy fp-card 재사용 + AllInOne 레이아웃 보강) */\n\n.passport-tab-v2 {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  height: 100%;\n  margin: 0 -8px;\n}\n\n.passport-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.passport-layout {\n  display: grid;\n  grid-template-columns: 1fr 200px;\n  gap: 12px;\n  align-items: start;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.passport-grid-area {\n  min-width: 0;\n  overflow-anchor: none;\n}\n\n/* 카드 그리드 — 2열 고정, 카드 사이즈 축소 */\n.passport-tab-v2 .fp-card-grid {\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  margin-top: 0;\n}\n.passport-tab-v2 .fp-card-image {\n  aspect-ratio: 3 / 4;\n  background: #fff;\n  overflow: clip;\n  scroll-behavior: auto;\n  overscroll-behavior: contain;\n}\n.passport-tab-v2 .fp-card {\n  overflow: clip;\n}\n.passport-tab-v2 .fp-card-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  padding: 4px;\n  box-sizing: border-box;\n  display: block;\n}\n.passport-tab-v2 .fp-card-store-label {\n  font-size: 11px;\n}\n.passport-tab-v2 .fp-card-bottom {\n  padding: 2px 4px;\n}\n.passport-tab-v2 .fp-card-select-antd .ant-select-selector {\n  height: 22px !important;\n  padding: 0 6px !important;\n  font-size: 12px !important;\n}\n.passport-tab-v2 .fp-card-select-antd .ant-select-selection-item {\n  line-height: 20px !important;\n  font-size: 12px !important;\n}\n.passport-tab-v2 .fp-card-meta {\n  margin-top: 2px;\n}\n\n.passport-tab-v2 .fp-card {\n  position: relative;\n}\n\n.fp-card-meta {\n  margin-top: 4px;\n  text-align: right;\n}\n\n.fp-card-busy-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n  border-radius: 10px;\n}\n\n.expired-card {\n  opacity: 0.55;\n}\n.expired-card .fp-card-placeholder {\n  background: linear-gradient(145deg, #90A4AE, #546E7A);\n}\n\n/* 우측 신규 발급 사이드 */\n.passport-register-side {\n  position: sticky;\n  top: 0;\n}\n\n.passport-register-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 10px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n}\n\n.passport-register-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #334155;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.passport-form-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #546E7A;\n  margin-bottom: 4px;\n}\n\n/* 좁은 화면 (태블릿 세로) — 사이드를 위로 */\n@media (max-width: 900px) {\n  .passport-layout {\n    grid-template-columns: 1fr;\n  }\n  .passport-register-side {\n    position: static;\n  }\n}\n\n/* 미사용 expired 클래스 정리 */\n.expired-card { display: none; }\n\n/* 새 여권 발급 폼 입력 높이 — 대상 Select 와 발급일 DatePicker 동일 24px */\n.passport-register-card .ant-select-sm .ant-select-selector,\n.passport-register-card .ant-picker-small {\n  height: 24px !important;\n  min-height: 24px !important;\n  line-height: 22px !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.passport-register-card .ant-picker-small .ant-picker-input > input {\n  font-size: 12px !important;\n  height: 22px !important;\n  line-height: 22px !important;\n}\n.passport-register-card .ant-select-sm .ant-select-selection-item {\n  line-height: 22px !important;\n  font-size: 12px !important;\n}\n\n/* 요약 바 폰트 (가족 N명 · 전체 여권 N장) — 가독성 향상 */\n.passport-tab-v2 .fp-summary-bar {\n  font-size: 17px;\n  padding: 10px 16px;\n  color: #37474F;\n}\n.passport-tab-v2 .fp-summary-bar strong {\n  font-size: 19px;\n  color: #1565C0;\n}\n\n/* 2026-09 여권 업무 재배치: 발급 → 보유 현황 → 양도 */\n.passport-tab-v2 {\n  gap: 12px;\n  min-height: 0;\n  margin: 0;\n  padding: 0 10px 14px;\n  overflow-y: auto;\n  overflow-anchor: none;\n  overscroll-behavior-y: contain;\n  touch-action: pan-y;\n  -webkit-overflow-scrolling: touch;\n}\n\n.passport-toolbar {\n  flex-wrap: nowrap;\n  gap: 12px;\n  padding-top: 2px;\n}\n\n.passport-history-button.ant-btn {\n  height: 42px;\n  margin-left: 4px;\n  padding: 0 16px;\n  border-color: #cbd5e1;\n  border-radius: 9px;\n  color: #334155;\n  font-size: 14px;\n  font-weight: 700;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n}\n\n.passport-history-button.ant-btn:active {\n  background: #f1f5f9;\n}\n\n.passport-tab-v2 .fp-summary-bar {\n  min-height: 42px;\n  padding: 8px 16px;\n  border: 1px solid #fde7ad;\n  border-radius: 9px;\n  background: #fffbeb;\n  color: #475569;\n  font-size: 15px;\n}\n\n.passport-tab-v2 .fp-summary-bar strong {\n  color: #0f6ead;\n  font-size: 18px;\n}\n\n.passport-register-card {\n  display: grid;\n  grid-template-columns: minmax(220px, 0.7fr) minmax(460px, 1.8fr);\n  align-items: center;\n  gap: 18px;\n  padding: 14px 16px;\n  border: 1px solid #cbd5e1;\n  border-left: 5px solid #176da5;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.06);\n}\n\n.passport-register-intro {\n  min-width: 0;\n}\n\n.passport-register-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n  color: #123b59;\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.passport-register-intro .ant-typography {\n  font-size: 13px;\n}\n\n.passport-register-fields {\n  display: grid;\n  grid-template-columns: minmax(150px, 1fr) minmax(170px, 1fr) minmax(150px, 0.8fr);\n  align-items: start;\n  gap: 10px;\n}\n\n.passport-form-field {\n  min-width: 0;\n}\n\n.passport-form-label {\n  margin-bottom: 5px;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.passport-register-card .ant-select {\n  height: 42px !important;\n}\n\n.passport-register-card .ant-select-selector,\n.passport-register-card .ant-picker {\n  height: 42px !important;\n  min-height: 42px !important;\n  border-radius: 8px !important;\n  font-size: 14px !important;\n}\n\n.passport-register-card .ant-select-selection-item {\n  line-height: 40px !important;\n  font-size: 14px !important;\n  font-weight: 600;\n}\n\n.passport-register-card .ant-picker-input > input {\n  height: 40px !important;\n  font-size: 14px !important;\n}\n\n.passport-register-button.ant-btn {\n  width: 100%;\n  height: 42px;\n  border-radius: 8px;\n  background: #176da5;\n  font-size: 15px;\n  font-weight: 800;\n  box-shadow: none;\n}\n\n.passport-register-action {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n  padding-top: 23px;\n}\n\n.passport-register-note {\n  min-height: 16px;\n  padding: 0 2px;\n  color: #8a6110;\n  font-size: 11px;\n  line-height: 1.35;\n  text-align: center;\n}\n\n.passport-section-heading {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  padding: 2px 4px 0;\n}\n\n.passport-section-heading > div {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n}\n\n.passport-section-heading strong {\n  color: #1e293b;\n  font-size: 17px;\n}\n\n.passport-section-heading span {\n  color: #64748b;\n  font-size: 13px;\n}\n\n.passport-grid-area {\n  min-width: 0;\n  padding-bottom: 4px;\n}\n\n.passport-tab-v2 .fp-card-grid {\n  grid-template-columns: repeat(auto-fit, minmax(245px, 300px));\n  align-items: start;\n  gap: 12px;\n  margin: 0;\n}\n\n.passport-tab-v2 .fp-card {\n  position: relative;\n  overflow: hidden;\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.07);\n  transition: none;\n}\n\n.passport-tab-v2 .fp-card:hover {\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.07);\n}\n\n.passport-card-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 58px;\n  padding: 8px 10px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #eef6fb;\n}\n\n.passport-card-heading > div {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.passport-card-eyebrow {\n  width: fit-content;\n  margin-bottom: 2px;\n  padding: 2px 7px;\n  border-radius: 999px;\n  background: #d9eefa;\n  color: #0f5f91;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.passport-card-owner {\n  overflow: hidden;\n  color: #123b59;\n  font-size: 19px;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.passport-tab-v2 .fp-card-delete {\n  position: static;\n  width: auto;\n  height: 32px;\n  min-height: 32px;\n  padding: 0 10px;\n  border: 1px solid #fecaca;\n  border-radius: 7px;\n  background: #fff;\n  color: #b91c1c;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.passport-tab-v2 .fp-card-delete:active {\n  background: #fef2f2;\n}\n\n.passport-tab-v2 .fp-card-image {\n  position: relative;\n  width: 100%;\n  height: clamp(185px, 22vh, 245px);\n  aspect-ratio: auto;\n  overflow: hidden;\n  background: #e8eef3;\n}\n\n.passport-tab-v2 .fp-card-image img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 8px;\n  box-sizing: border-box;\n  object-fit: contain;\n}\n\n.passport-tab-v2 .fp-card-store-label {\n  bottom: 8px;\n  left: 10px;\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: rgba(10, 51, 79, 0.92);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 800;\n  text-shadow: none;\n}\n\n.passport-tab-v2 .fp-card-bottom {\n  padding: 10px;\n}\n\n.passport-transfer-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #334155;\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.passport-transfer-help {\n  margin: 2px 0 7px;\n  color: #64748b;\n  font-size: 11px;\n}\n\n.passport-transfer-select-wrap {\n  width: 100%;\n}\n\n.passport-tab-v2 .fp-card-select-antd .ant-select-selector {\n  height: 40px !important;\n  min-height: 40px !important;\n  padding: 0 10px !important;\n  border: 1px solid #94a3b8 !important;\n  border-radius: 8px !important;\n}\n\n.passport-tab-v2 .fp-card-select-antd .ant-select-selection-item {\n  line-height: 38px !important;\n  color: #1e293b;\n  font-size: 14px !important;\n  font-weight: 700;\n}\n\n.passport-tab-v2 .fp-card-meta {\n  margin-top: 6px;\n  text-align: right;\n}\n\n.passport-tab-v2 .fp-card-meta .ant-typography {\n  font-size: 12px;\n}\n\n.fp-card-busy-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.68);\n}\n\n@media (max-width: 1100px) {\n  .passport-register-card {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .passport-tab-v2 .fp-card-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 760px) {\n  .passport-toolbar,\n  .passport-section-heading > div {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .passport-register-fields {\n    grid-template-columns: 1fr;\n  }\n\n  .passport-register-action {\n    padding-top: 0;\n  }\n\n  .passport-register-button.ant-btn {\n    width: 100%;\n  }\n\n  .passport-tab-v2 .fp-card-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
